import { createSlice } from '@reduxjs/toolkit'

const idleSaveState = {
    saveStatus: 'idle',
    saveError: ''
}

const initialState = {
    unsavedSections: {},
    ...idleSaveState
}

const slice = createSlice({
    name: 'settings',
    initialState,
    reducers: {
        setUnsavedChanges: (state, { payload: { section, hasChanges } }) => ({
            ...state,
            unsavedSections: { ...state.unsavedSections, [section]: hasChanges }
        }),
        resetUnsavedChanges: (state) => ({ ...state, unsavedSections: {} }),
        setSaveState: (state, { payload }) => ({ ...state, ...idleSaveState, ...payload })
    }
})

const { reducer, actions } = slice

export const {
    setUnsavedChanges,
    resetUnsavedChanges,
    setSaveState
  } = actions

export const selectHasUnsavedChanges = (state) => Object.values(state.settings.unsavedSections).some(Boolean)

export default reducer
